import { SocietyCorporateId } from 'types/Society';
import { loginsByCorporateId } from '../constants/loginsByCorporateId';

export const getLoginByCorporateId = () => {
  const corporateId =
    (process.env.REACT_APP_UI_CORPORATE_ID as SocietyCorporateId) ||
    SocietyCorporateId.DEFAULT;

  return loginsByCorporateId[corporateId];
};
